import React, { useState } from 'react';
import moment from 'moment';
import PersonIcon from '@material-ui/icons/Person';
import DeleteIcon from '@material-ui/icons/Delete';
import { Tooltip, Button, Typography, Box } from '@material-ui/core';
import { CountdownTimer } from './CountdownTimer';

const tableConfig = props => {
  return {
    columns: [
      {
        title: 'Invoice ID',
        field: 'invoice_id',
        filterAndSearch: true,
        render: rowData => <div>{rowData.invoice_id || '-'}</div>
      },
      {
        title: 'Status',
        field: 'fulfillment_status',
        filterAndSearch: false,
        render: rowData => (
          // <div>
          <Tooltip
            // open={rowData.order_payment && rowData.order_payment.error_desc}
            title={
              <Box>
                <Typography>
                  {(rowData.order_payment &&
                    rowData.order_payment?.error_desc) ||
                    rowData?.order_payment?.payment_status ||
                    '-'}
                </Typography>
              </Box>
            }
            arrow
            placement="right-end"
            // title="Add"
          >
            <div style={{ width: 'fit-content' }}>
              {rowData.fulfillment_status || '-'}
            </div>
          </Tooltip>
        )
        // </div>
      },
      {
        title: 'Timer',
        field: 'timer',
        filterAndSearch: false,
        render: rowData => (
          // <div>

          <div
            style={{ width: 'fit-content', cursor: 'pointer' }}
            onClick={() =>
              rowData.fulfillment_status === 'PENDING' &&
              props.handleTimerClick &&
              props.handleTimerClick(rowData.order_date_system, rowData)
            }
          >
            {rowData.fulfillment_status === 'PENDING' ? (
              <CountdownTimer
                orderDate={rowData.order_date_system}
                isAccepted={rowData.fulfillment_status !== 'PENDING'}
                sellerDetails={rowData.food_seller}
              />
            ) : (
              '-'
            )}
          </div>
        )
        // </div>
      },
      {
        title: 'Order Type',
        field: 'advance_booking',
        filterAndSearch: true,
        width: '12%',
        render: rowData => {
          const className = rowData.advance_booking
            ? 'green-label'
            : 'orange-label';
          return (
            <div className={`text-capitalize colored-label ${className}`}>
              {rowData.advance_booking ? 'Advance Booking' : 'Normal Booking'}
            </div>
          );
        }
      },
      {
        title: 'Total Amount',
        field: 'net_amount',
        filterAndSearch: true,
        render: rowData => (
          <div>
            <span>&#8377;{rowData.net_amount}</span>
          </div>
        )
      },
      {
        title: 'Delivery Type',
        field: 'delivery_option.option_id',
        filterAndSearch: false,
        render: rowData => {
          const className =
            rowData.delivery_option &&
            rowData.delivery_option.option_id &&
            rowData.delivery_option.option_code === 'Dunzo'
              ? 'green-label'
              : 'orange-label';
          return (
            <Tooltip
              title={
                <span>
                  <strong>Delivery Option</strong>: <br />
                  {(rowData.delivery_option &&
                    rowData.delivery_option.option_name) ||
                    '-'}
                </span>
              }
              arrow
              placement="right-end"
            >
              <div
                className={`text-capitalize colored-label gap-1 d-flex align-items-center justify-content-center ${className}`}
              >
                <span
                  className="delivery-type-icon"
                  title={
                    rowData.delivery_option &&
                    rowData.delivery_option.option_id &&
                    rowData.delivery_option.option_name
                  }
                >
                  {rowData.delivery_option.option_code === 'EFDelivery' ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Layer_1"
                      enable-background="new 0 0 64 64"
                      viewBox="0 0 64 64"
                      width="30"
                      height="30"
                    >
                      <g fill="currentColor">
                        <path d="m17.6 27.5c0-.8-.1-1.4-.1-2-4.8 0-9.6 0-14.4 0 0 .8.1 1.4.1 2z" />
                        <path d="m62.3 47.2c-.6-.8-1.1-1.6-1.8-2.3-1.7-1.6-3.7-2.4-6-2.6-.8-.1-1.5-.3-1.9-1.2-1.1-3.2-3.2-5.5-6.2-7-.3-.2-.7-.4-.9-.7-.2-.2-.2-.7-.1-.9s.6-.4.9-.4c.4.1.7.4 1 .7.7.6 1.2 1.4 2 1.9 1.5 1 2.6.5 3.1-1.2.4-1.5.4-2.9.2-4.4-.3-1.7-1.8-2.5-3.3-1.6-.6.4-1.1 1-1.7 1.5-.3.3-.6.7-.9 1-.8.6-1.6.5-2.2-.3-.3-.4-.5-.9-.7-1.4-.5-.9-.8-.9-1.4-.2-.1.1-.1.2-.1.3-.1-.1-.1-.1-.2-.2 0-.2 0-.3 0-.5 0-1.3-.6-2-1.8-2.2-.5-.1-1-.1-1.5-.1-2.7 0-5-.9-6.9-2.8-.7-.6-1.2-1.3-1.9-2-.3-.3-.2-.5 0-.8.3-.4.6-.8.7-1.2.3-1.3-1-3.6-2.2-4-.9-.3-1.8-.3-2.7-.1-2.4.6-3.8 2.3-4.6 4.5-1.8 4.6-2.2 9.4-1.5 14.3.4 2.9 1.7 4.4 4.4 4.9 2.8.5 5.6.9 8.4 1.3 1.3.2 2.1.7 2.5 1.9.9 2.3 1.8 4.7 2.8 7 .2.5.5 1 .8 1.5.9 1.5 2.2 1.9 3.8 1.2 1.6-.6 2.4-1.9 2-3.5-.3-1.2-.8-2.4-1.2-3.6-.7-1.8-1.5-3.5-2-5.3-1-3.5-2.8-5.2-6.4-5.6-1.3-.2-2.7-.3-4-.5-1.4-.2-1.8-.8-1.7-2.2.1-1 .3-2 .4-3 .1-.7.4-.8 1-.5 2.2 1.4 4.5 2.3 7.1 2.7 1.2.2 2.5.4 3.7 0 .1.2.2.4.3.6.5 1.2 1.2 2.4 1.6 3.6 1.5 4.1 2.9 8.3 4.3 12.4.3.8.6.9 1.3.4.4-.3.8-.5 1.2-.8 3.6-2 7-1.8 10.3.7.8.7 1.6 1.4 2.4 2.1.2-.3 0-.9-.4-1.4z" />
                        <path d="m43.3 52.5c-.1 0-.3 0-.4 0-2.2 0-4.3 0-6.5 0-2.3 0-4.6 0-6.9 0-1.1 0-1.6-.4-1.9-1.4-.3-.9-.5-1.7-.8-2.6-.5-1.7-.7-3.5 0-5.2.1-.2.1-.5.2-.7.3-1.7-.4-2.6-2.1-2.8-.5 0-.9-.1-1.4-.1-3.4 0-6.8 0-10.2 0-2.7 0-5.4.1-8 .2-2.3.1-3 1-2.2 3.1.6 1.7.5 3.2 0 4.9-.6 2.2-1.2 4.4-1.7 6.6-.2.8.1 1.1.8 1.2s1.3.1 2 .1c.9 0 1.4-.4 1.6-1.3.1-.5.1-1.1.2-1.7.6-4.5 4-7.7 8.6-8.1 4.3-.3 8.1 2.5 9.3 6.9.3 1 .3 2 .5 3 .1.7.5 1 1.2 1.1h1.9 16.5c.5 0 .9-.1 1.1-.5.5-1.3-.3-2.6-1.8-2.7z" />
                        <path d="m54.3 47.6c-3.6 0-6.4 2.6-6.3 6.2 0 3.5 2.7 6.2 6.2 6.2s6.2-2.7 6.2-6.2-2.6-6.1-6.1-6.2z" />
                        <path d="m15.1 47.7c-3.5-.1-6.3 2.6-6.3 6-.1 3.5 2.6 6.3 6.2 6.3 3.5.1 6.2-2.6 6.3-6 0-3.6-2.6-6.3-6.2-6.3z" />
                        <path d="m9.4 32.4c-.1-1.1-.1-2.1-.2-3.3-2.1 0-4.1 0-6.1 0v9.3h14.3c0-3.2 0-6.2 0-9.3-2.1 0-4.1 0-6.1 0-.1 1.2-.1 2.3-.2 3.3-.5 0-1 0-1.7 0z" />
                        <path d="m31 14c2.2.5 4.6-.8 5.5-3 .3-.8.4-1.6.6-2.5.8.2 1.7.5 2.6.7.6.1.9 0 1-.5.1-.4-.1-.7-.7-.8-1-.3-2-.6-3.1-.9-.3-.1-.6-.3-.7-.5-1.2-2-3.5-2.9-5.7-2.3s-3.8 2.6-3.8 4.9c.1 2.4 1.7 4.4 4.3 4.9z" />
                      </g>
                    </svg>
                  ) : rowData.delivery_option.option_code === 'selfDelivery' ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 87.736 87.736"
                    >
                      <g>
                        <path
                          d="m58.514 41.095-8.387-.149c-.618-.011-1.244-.557-1.34-1.167l-2.3-14.621a2.746 2.746 0 0 0-.274-.863 2.938 2.938 0 0 0-2.728-1.885l-13.5.586c-1.629.071-2.954 1.455-2.954 3.086l.01 29.591c-.016 1.424-.082 3.49-.156 4.806l-.407 7.213c-.072 1.271-.696 3.259-1.364 4.342l-5.928 9.623a3.462 3.462 0 0 0-.413 2.711 3.465 3.465 0 0 0 1.684 2.167l1.326.739a3.664 3.664 0 0 0 1.788.462c1.297 0 2.518-.674 3.186-1.758l5.927-9.623c.828-1.343 1.635-3.621 1.838-5.188l1.707-13.193 1.847-.18 7.943 12.265c.693 1.072 1.372 3.049 1.482 4.317l.898 10.324c.142 1.635 1.33 2.776 2.888 2.776a3.34 3.34 0 0 0 1.119-.198l1.43-.507c1.783-.632 3.052-2.603 2.888-4.487l-.898-10.322c-.135-1.554-.765-3.874-1.435-5.282l-7.629-16.041c-.018-.038-.042-.072-.061-.109l-.032-2.852 12.184-.502a2.911 2.911 0 0 0 2.797-3.142c-.126-1.592-1.532-2.91-3.136-2.939zM34.321 19.35a9.64 9.64 0 0 0 3.228-.558 9.602 9.602 0 0 0 5.502-4.953 9.608 9.608 0 0 0 .388-7.393A9.692 9.692 0 0 0 34.319 0a9.657 9.657 0 0 0-3.227.556A9.61 9.61 0 0 0 25.59 5.51a9.606 9.606 0 0 0-.388 7.392 9.69 9.69 0 0 0 9.119 6.448z"
                          fill="currentColor"
                          opacity="1"
                          data-original="currentColor"
                          class=""
                        ></path>
                        <path
                          d="M68.272 22.931c-.114-1.634-1.544-2.891-3.198-2.791l-12.76.851a2.971 2.971 0 0 0-2.055 1.019 2.974 2.974 0 0 0-.733 2.177l.796 11.438a3.016 3.016 0 0 0 3.198 2.791l12.76-.851a2.971 2.971 0 0 0 2.055-1.019 2.974 2.974 0 0 0 .733-2.177l-.796-11.438z"
                          fill="currentColor"
                          opacity="1"
                          data-original="currentColor"
                          class=""
                        ></path>
                      </g>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 128 128"
                    >
                      <g>
                        <path
                          fill="currentColor"
                          fill-rule="evenodd"
                          d="M64.017 11.5c6.256-.053 11.093 3.051 14.428 7.207 3.378 4.21 5.055 9.309 5.055 12.794 0 6.934-3.872 12.047-8.768 17.76-.385.449-.776.901-1.17 1.358h-.001c-2.938 3.4-6.098 7.056-8.487 11.368-.414.747-1.545.734-1.943-.022-2.336-4.442-5.52-8.214-8.473-11.714l-.002-.002c-.315-.373-.628-.744-.936-1.112C48.866 43.354 45 38.248 45 31.501c0-3.244 1.592-8.293 4.878-12.545 3.245-4.196 7.966-7.402 14.14-7.455zM64 40a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0-4a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM53.699 56.417a.993.993 0 0 1 1.119.314c3.28 4.135 6.073 8.417 7.228 13.697a2 2 0 0 0 3.894.057c1.312-5.248 4.179-9.464 7.5-13.53.27-.33.72-.45 1.12-.3l3.214 1.208 22.694 8.847c.833.325.854 1.495.033 1.85l-36.11 15.593a1 1 0 0 1-.79.002l-36.557-15.61c-.824-.351-.806-1.525.03-1.85l22.653-8.832zM106 72.063a1 1 0 0 0-1.396-.918l-38 16.41a1 1 0 0 0-.604.918v24.916a1 1 0 0 0 1.405.915l38-16.841a1 1 0 0 0 .595-.915zM61.393 87.563a1 1 0 0 1 .607.92v24.928a1 1 0 0 1-1.401.916l-38.5-16.87a1 1 0 0 1-.599-.916V72.043a1 1 0 0 1 1.393-.92zM97 89.5a2 2 0 1 0 0 4h3.5a2 2 0 1 0 0-4zm-7 3a2 2 0 1 0 0 4h3.5a2 2 0 1 0 0-4z"
                          clip-rule="evenodd"
                          opacity="1"
                          data-original="currentColor"
                          class=""
                        ></path>
                      </g>
                    </svg>
                  )}
                </span>
                <span className="delivery-type-label">
                  {rowData.delivery_option &&
                    rowData.delivery_option.option_id &&
                    rowData.delivery_option.option_name}
                </span>
              </div>
            </Tooltip>
          );
        }
      },
      {
        title: 'Delivery Charge',
        field: 'delivery_charges',
        filterAndSearch: true,
        render: rowData => (
          <div>
            <span>&#8377;{rowData.delivery_charges}</span>
          </div>
        )
      },
      {
        title: 'Delivery Status',
        field: 'dunzo_status',
        filterAndSearch: false,
        render: rowData => <div>{rowData.dunzo_status || '-'}</div>
      },
      {
        title: 'Delivery Task ID',
        field: 'delivery_task_id',
        filterAndSearch: true,
        render: rowData => <div>{rowData.delivery_task_id || '-'}</div>
      },
      {
        title: 'Total Dishes',
        field: 'quantity',
        filterAndSearch: false,
        render: rowData => <div>{rowData.quantity || 0}</div>
      },
      {
        title: 'Business Name',
        field: 'food_seller.user.business_name',
        filterAndSearch: true,
        width: '15%',
        render: rowData => (
          <Tooltip
            title={
              <span style={{ fontSize: '12px' }}>
                <strong>Business Address</strong>: <br />
                {(rowData &&
                  rowData.food_seller &&
                  rowData.food_seller.address_line1) ||
                  '-'}
                <br />
                <br />
                <strong>Business Pincode</strong>:{' '}
                {(rowData &&
                  rowData.food_seller &&
                  rowData.food_seller.pin_code) ||
                  '-'}
              </span>
            }
            arrow
          >
            <div>
              {(rowData.food_seller &&
                rowData.food_seller.user &&
                rowData.food_seller.business_name) ||
                '-'}
            </div>
          </Tooltip>
        )
      },

      // {
      // 	title: 'Business Name', field: 'food_seller.business_name', filterAndSearch: true,
      // 	render: rowData => <Tooltip
      // 		title={
      // 			<span>
      // 				<strong>Seller name</strong>: <br />
      // 				{(rowData.food_seller && rowData.food_seller.user && rowData.food_seller.user.name) || "-"}
      // 			</span>
      // 		}
      // 		arrow
      // 		placement="left-start"
      // 	>
      // 		<div>{(rowData.food_seller && rowData.food_seller.business_name) || "-"}</div>
      // 	</Tooltip>
      // },
      // {
      // 	title: 'Seller Name', field: 'food_seller.user.name', filterAndSearch: true,
      // 	render: rowData => <div>{(rowData.food_seller && rowData.food_seller.user && rowData.food_seller.user.name) || "-"}</div>
      // },
      // {
      // 	title: 'Business Address', field: 'food_seller.address_line1', filterAndSearch: true, width: '15%',
      // 	render: rowData => <div>{(rowData && rowData.food_seller && rowData.food_seller.address_line1) || "-"}</div>
      // },
      // {
      // 	title: 'Business Pincode', field: 'food_seller.pin_code', filterAndSearch: true, width: '15%',
      // 	render: rowData => <Tooltip
      // 		title={
      // 			<span>
      // 				<strong>Seller Address</strong>: <br />
      // 				{(rowData && rowData.food_seller && rowData.food_seller.address_line1) || "-"}
      // 			</span>
      // 		}
      // 		arrow
      // 	>
      // 		<div>
      // 			{(rowData && rowData.food_seller && rowData.food_seller.pin_code) || "-"}
      // 		</div>
      // 	</Tooltip>
      // },
      {
        title: 'Buyer Name',
        field: 'food_buyer.user.name',
        filterAndSearch: true,
        render: rowData => (
          <div>
            {(rowData.food_buyer &&
              rowData.food_buyer.user &&
              rowData.food_buyer.user.name) ||
              '-'}
          </div>
        )
      },
      {
        title: 'Delivery Address',
        field: 'delivery_address.address',
        filterAndSearch: true,
        render: rowData => (
          <div>
            {(rowData.delivery_address && rowData.delivery_address.address) ||
              '-'}
          </div>
        )
      },
      {
        title: 'Delivery Pincode',
        field: 'delivery_address.pin_code',
        filterAndSearch: true,
        render: rowData => (
          <div>
            {(rowData.delivery_address && rowData.delivery_address.pin_code) ||
              '-'}
          </div>
        )
      },
      {
        title: 'Ordered At',
        field: 'order_date_system',
        filterAndSearch: false,
        render: rowData => (
          <div>
            {rowData.order_date_system
              ? moment
                  .utc(rowData.order_date_system)
                  .local()
                  .format('DD-MM-YYYY, h:mm A')
              : '-'}
          </div>
        )
      },
      {
        title: 'Advance Booking Delivery Date',
        field: 'advance_booking_delivery_date',
        filterAndSearch: false,
        render: rowData => (
          <div>
            {rowData.advance_booking_delivery_date
              ? moment
                  .utc(rowData.advance_booking_delivery_date)
                  .local()
                  .format('DD-MM-YYYY, h:mm A')
              : '-'}
          </div>
        )
      }
    ]
  };
};

export const finishedOrdersTableConfig = (props, verifyPayment) => ({
  columns: [
    {
      title: 'Invoice ID',
      field: 'invoice_id',
      filterAndSearch: true,
      render: rowData => <div>{rowData.invoice_id || '-'}</div>
    },
    {
      title: 'Payment Status',
      field: 'order_payment.payment_status',
      filterAndSearch: false,
      render: rowData => (
        <div>
          {rowData?.order_payment?.payment_status == 'FAILED' ||
          rowData?.order_payment?.payment_status == 'UNPAID' ? (
            rowData.order_payment && rowData.order_payment.error_desc ? (
              <>
                {rowData?.order_payment?.payment_status}
                {rowData.order_payment && (
                  <p style={{ color: 'red', fontSize: '10px', margin: 0 }}>
                    {(rowData.order_payment.error_desc == 'payment_timed_out' &&
                      'Payment time out from customer side.') ||
                      (rowData.order_payment.error_desc == 'payment_declined' &&
                        'Bank side issue, Payment was declined.') ||
                      (rowData.order_payment.error_desc ==
                        'payment_not_attempted' &&
                        'Payment is not attempted.')}
                  </p>
                )}
              </>
            ) : (
              <button
                className="btn btn-warning btn-xs"
                style={{ fontSize: '10px', color: '#fff' }}
                onClick={() => verifyPayment(rowData.order_id)}
              >
                Verify
              </button>
            )
          ) : (
            <div>{rowData?.order_payment?.payment_status}</div>
          )}
          {/* {rowData.order_payment && rowData.order_payment.error_desc || rowData.order_payment.payment_status || '-'} */}
        </div>
      )
    },
    {
      title: 'Status',
      field: 'fulfillment_status',
      filterAndSearch: false,
      render: rowData => (
        <Tooltip
          // open={rowData.order_payment && rowData.order_payment.error_desc}
          title={
            <Box>
              <Typography>
                {(rowData.order_payment && rowData.order_payment.error_desc) ||
                  rowData.order_payment?.payment_status ||
                  '-'}
              </Typography>
            </Box>
          }
          arrow
          placement="right-end"
          // title="Add"
        >
          <div style={{ width: 'fit-content' }}>
            {rowData.fulfillment_status || '-'}
          </div>
        </Tooltip>
      )
    },
    {
      title: 'Order Type',
      field: 'advance_booking',
      filterAndSearch: true,
      width: '12%',
      render: rowData => {
        const className = rowData.advance_booking
          ? 'green-label'
          : 'orange-label';
        return (
          <div className={`text-capitalize colored-label ${className}`}>
            {rowData.advance_booking ? 'Advance Booking' : 'Normal Booking'}
          </div>
        );
      }
    },
    {
      title: 'Business Name',
      field: 'food_seller.business_name',
      filterAndSearch: true,
      render: rowData => (
        <div>
          {(rowData.food_seller && rowData.food_seller.business_name) || '-'}
        </div>
      )
    },
    {
      title: 'Total Amount',
      field: 'net_amount',
      filterAndSearch: true,
      render: rowData => <div>{<span>&#8377;{rowData.net_amount}</span>}</div>
      //render: rowData => console.log("row1111", rowData)
    },
    {
      title: 'Delivery Charge',
      field: 'delivery_charges',
      filterAndSearch: true,
      render: rowData => (
        <div>
          <span>&#8377;{rowData.delivery_charges}</span>{' '}
        </div>
      )
    },
    {
      title: 'Total Dishes',
      field: 'quantity',
      filterAndSearch: false,
      render: rowData => <div>{rowData.quantity || 0}</div>
    },
    {
      title: 'Delivery Type',
      field: 'delivery_option.option_id',
      filterAndSearch: false,
      render: rowData => {
        const className =
          rowData.delivery_option &&
          rowData.delivery_option.option_id &&
          rowData.delivery_option.option_code === 'Dunzo'
            ? 'green-label'
            : 'orange-label';
        return (
          <div className={`text-capitalize colored-label ${className}`}>
            {rowData.delivery_option &&
              rowData.delivery_option.option_id &&
              rowData.delivery_option.option_name}
          </div>
        );
      }
    },
    // {
    // 	title: 'Seller Name', field: 'food_seller.user.business_name', filterAndSearch: true,
    // 	render: rowData => <div>{(rowData.food_seller && rowData.food_seller.user && rowData.food_seller.business_name) || "-"}</div>
    // },
    {
      title: 'Seller Name',
      field: 'food_seller.user.business_name',
      filterAndSearch: true,
      width: '15%',
      render: rowData => (
        <Tooltip
          title={
            <span style={{ fontSize: '12px' }}>
              <strong>Business Address</strong>: <br />
              {(rowData &&
                rowData.food_seller &&
                rowData.food_seller.address_line1) ||
                '-'}
              <br />
              <br />
              <strong>Business Pincode</strong>:{' '}
              {(rowData &&
                rowData.food_seller &&
                rowData.food_seller.pin_code) ||
                '-'}
            </span>
          }
          arrow
        >
          <div>
            {(rowData.food_seller &&
              rowData.food_seller.user &&
              rowData.food_seller.business_name) ||
              '-'}
          </div>
        </Tooltip>
      )
    },
    {
      title: 'Delivery Task ID',
      field: 'delivery_task_id',
      filterAndSearch: true,
      render: rowData => <div>{rowData.delivery_task_id || '-'}</div>
    },
    {
      title: 'Delivery Status',
      field: 'delivery_status',
      filterAndSearch: false,
      render: rowData => (
        <div>
          {(rowData.delivery_status && rowData.delivery_status.toUpperCase()) ||
            '-'}
        </div>
      )
    },

    // {
    // 	title: 'Business Address', field: 'food_seller.address_line1', filterAndSearch: true, width: '15%',
    // 	render: rowData => <div>{(rowData && rowData.food_seller && rowData.food_seller.address_line1) || "-"}</div>
    // },
    // {
    // 	title: 'Business Pincode', field: 'food_seller.pin_code', filterAndSearch: true, width: '15%',
    // 	render: rowData => <div>{(rowData && rowData.food_seller && rowData.food_seller.pin_code) || "-"}</div>
    // },
    {
      title: 'Buyer Name',
      field: 'food_buyer.user.name',
      filterAndSearch: true,
      render: rowData => (
        <div>
          {(rowData.food_buyer &&
            rowData.food_buyer.user &&
            rowData.food_buyer.user.name) ||
            '-'}
        </div>
      )
    },
    {
      title: 'Delivery Address',
      field: 'delivery_address.address',
      filterAndSearch: true,
      render: rowData => (
        <div>
          {(rowData.delivery_address && rowData.delivery_address.address) ||
            '-'}
        </div>
      )
    },
    {
      title: 'Delivery Pincode',
      field: 'delivery_address.pin_code',
      filterAndSearch: true,
      render: rowData => (
        <div>
          {(rowData.delivery_address && rowData.delivery_address.pin_code) ||
            '-'}
        </div>
      )
    },
    {
      title: 'Ordered At',
      field: 'order_date_system',
      filterAndSearch: false,
      render: rowData => (
        <div>
          {rowData.order_date_system
            ? moment
                .utc(rowData.order_date_system)
                .local()
                .format('DD-MM-YYYY, h:mm A')
            : '-'}
        </div>
      )
    },
    {
      title: 'Advance Booking Delivery Date',
      field: 'advance_booking_delivery_date',
      filterAndSearch: false,
      render: rowData => (
        <div>
          {rowData.advance_booking_delivery_date
            ? moment
                .utc(rowData.advance_booking_delivery_date)
                .local()
                .format('DD-MM-YYYY, h:mm A')
            : '-'}
        </div>
      )
    },
    {
      title: 'Delivered At',
      field: 'delivered_date_local',
      filterAndSearch: false,
      render: rowData => (
        <div>
          {rowData.delivered_date_local
            ? moment
                .utc(rowData.delivered_date_local)
                .local()
                .format('DD-MM-YYYY, h:mm A')
            : '-'}
        </div>
      )
    }
  ]
});

export const data = [
  {
    _id: '5f3bbcf8bd2288dcdccf35d2',
    item: 'Test item',
    orderId: 1234,
    weight: '100gm',
    qty: 2,
    price: 200,
    buyer: 'Test Buyer',
    seller: 'Test Seller',
    orderedAt: 'Apr 2020',
    status: 'pending'
  },
  {
    _id: '5f3bbcf8958c595f4833db3e',
    item: 'Test item',
    orderId: 1234,
    weight: '100gm',
    qty: 2,
    price: 200,
    buyer: 'Test Buyer',
    seller: 'Test Seller',
    orderedAt: 'Apr 2020',
    status: 'pending'
  },
  {
    _id: '5f3bbcf8ff0a6a4cf4e81ba9',
    item: 'Test item',
    orderId: 1234,
    weight: '100gm',
    qty: 2,
    price: 200,
    buyer: 'Test Buyer',
    seller: 'Test Seller',
    orderedAt: 'Apr 2020',
    status: 'pending'
  },
  {
    _id: '5f3bbcf8da097fceb33eda11',
    item: 'Test item',
    orderId: 1234,
    weight: '100gm',
    qty: 2,
    price: 200,
    buyer: 'Test Buyer',
    seller: 'Test Seller',
    orderedAt: 'Apr 2020',
    status: 'pending'
  },
  {
    _id: '5f3bbcf815c275e3c40187bd',
    item: 'Test item',
    orderId: 1234,
    weight: '100gm',
    qty: 2,
    price: 200,
    buyer: 'Test Buyer',
    seller: 'Test Seller',
    orderedAt: 'Apr 2020',
    status: 'pending'
  },
  {
    _id: '5f3bbcf8da5fef114c2204e7',
    item: 'Test item',
    orderId: 1234,
    weight: '100gm',
    qty: 2,
    price: 200,
    buyer: 'Test Buyer',
    seller: 'Test Seller',
    orderedAt: 'Apr 2020',
    status: 'pending'
  }
];
export const data2 = [
  {
    _id: '5f3bbcf8bd2288dcdccf35d2',
    item: 'Delivered',
    orderId: 1234,
    weight: '100gm',
    qty: 2,
    price: 200,
    buyer: 'Test Buyer',
    seller: 'Test Seller',
    orderedAt: 'Apr 2020',
    status: 'pending'
  }
];
export const data3 = [
  {
    _id: '5f3bbcf8bd2288dcdccf35d2',
    item: 'Finished',
    orderId: 1234,
    weight: '100gm',
    qty: 2,
    price: 200,
    buyer: 'Test Buyer',
    seller: 'Test Seller',
    orderedAt: 'Apr 2020',
    status: 'pending'
  }
];
export default tableConfig;
